import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  value:"选中radio的值",
  fontFamily: "字体",
  hoverFontFamily: "hover字体",
  fontSize: "字体大小",
  hoverFontSize: "hover字体大小",
  fontWeight: "字重",
  hoverFontWeight: "hover字重",
  color: "字体颜色",
  textIsThemeColor: "字体颜色跟随主题色",
  hoverColor: "hover字体颜色",
  hoverTextIsThemeColor: "hover字体颜色跟随主题色",
  bgColor: "背景颜色",
  hoverBgColor: "hover背景颜色",
  lineHeight: "行高",
  hoverLineHeight: "hover行高",
  letterSpacing: "字间距",
  hoverLetterSpacing: "hover字间距",
  fontStyle: "字体样式",
  hoverFontStyle: "hover字体样式",
  textAlign: "对齐方式",
  hoverTextAlign: "hover对齐方式",
  writingMode: "排列方式",
  hoverWritingMode: "hover排列方式",
  textDecoration: "下划线",
  hoverTextDecoration: "hover下划线",
  textIndent: "文本缩进",
  hoverTextIndent: "hover文本缩进",
  borderTopLeftRadius: "左上角圆角",
  borderTopRightRadius: "右上角圆角",
  borderBottomLeftRadius: "左下角圆角",
  borderBottomRightRadius: "右下角圆角",
  borderColor: "边框颜色",
  borderStyle: "边框类型", // solid dashed dotted
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色跟随主题色",
  hoverBorderColor: "hover边框颜色",
  hoverBorderStyle: "hover边框类型",
  hoverBorderWidth: "hover边框宽度",
  hoverBorderIsThemeColor: "hover时边框是否跟随主题色",
  activeIndex: "tab选中项索引",
  bgColorIsThemeColor: "hover下划线是否跟随主题色",
  hoverBgColorIsThemeColor: "hover背景是否跟随主题色",
  opacity: "透明度",
  bgType: "背景颜色类型",
  allBgColor: "全局背景颜色",
  bgStartColor: "背景渐变色开始色值",
  bgEndColor: "背景渐变色结束色值",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  padding: "内边距",
  paddingTop: "上内边距",
  paddingRight: "右内边距",
  paddingLeft: "左内边距",
  paddingBottom: "下内边距",
  iconPosition: "图标位置", // 左 右
  iconSrc1: "图标链接-未选中",
  iconType1: "图标类型-未选中", // img icon
  ionSrc2: "图标链接-选中",
  iconType2: "图标类型-选中", // img icon
  iconWidth: "图标大小",
  marginRight: "radio间距",
  iconColorIsThemeColor: "图标颜色跟随主题色",
  iconColor: "图标颜色",
  itemPadding: "radio内边距",
  itemPaddingTop: "radio上内边距",
  itemPaddingRight: "radio右内边距",
  itemPaddingLeft: "radio左内边距",
  itemPaddingBottom: "radio下内边距",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
}
export const getOptDes = toSelectOpt.bind(this, optDes)
